import { motion } from 'framer-motion'

const Contact = () => {
  return (
    <div name='contact' className='relative w-full h-full bg-[rgb(255,255,255)] flex justify-center items-center px-2'>
        <form method='POST' action="https://getform.io/f/6ed695f3-bbbe-4e31-a176-659cffc166d2" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-2 border-[#d4d4d4] cursor-default'>Contact</p>
                <p className='py-4'> Submit the form below or shoot me an email - <span className='font-bold'><a href="mailto:contact.patryk.romanski@gmail.com" className='hover:underline'>contact.patryk.romanski@gmail.com</a></span></p>
            </div>
            <input className='p-2 border-2 border-gray rounded' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 border-2 border-gray rounded' type="email" placeholder='Email' name='email' />
            <textarea className='p-2 border-2 border-gray rounded resize-none h-48' name="message" placeholder='Message' rows="10"></textarea>
            <motion.button whileHover={{scale: 1.02}} className='font-bold bg-[#ececec] rounded hover:text-white hover:bg-[#5e5e5e]  px-4 py-4 my-8 mx-auto flex items-center duration-300'>Let's colaborate!</motion.button>
        </form>

    </div>
  )
}

export default Contact